import React, { useEffect, useState } from "react";

import Drawer from "../../components/ui/Drawer";
import { downloadImage } from "../../utils/downloadImage";

import PDFIcon from "../../static/icons/pdf.png";
import { DocumentNotFound } from "./DocumentNotFound";
import { DocumentsLoader } from "./DocumentsLoader";

const FILE_TYPES = {
  PDF: "pdf",
  JPG: "jpg",
  JPEG: "jpeg",
  PNG: "png",
};

const ViewDocumentDrawer = ({ title, onClose, cardItem }) => {
  const [loading, setLoading] = useState(false);
  const [src, setSrc] = useState("");
  const [fileType, setFileType] = useState("");

  useEffect(() => {
    setLoading(true);
    const fileName =
      cardItem.paymentReceiptFileName ||
      cardItem.paymentReceiptsFileName ||
      cardItem.imageName ||
      cardItem.imageUrl;

    downloadImage({
      fileName,
    })
      .then((res) => {
        const { data } = res;
        if (!data) return setLoading(false);
        const filetype = fileName.split(".").pop();

        if (filetype === FILE_TYPES.PDF) {
          setFileType(FILE_TYPES.PDF);
          setSrc("data:application/pdf;base64," + data?.body);
        } else if (filetype === FILE_TYPES.PNG) {
          setFileType(FILE_TYPES.PNG);
          setSrc("data:image/png;base64," + data?.body);
        } else {
          setFileType(FILE_TYPES.JPG);
          setSrc("data:image/jpeg;base64," + data?.body);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  return (
    <>
      <Drawer title={title} onClose={onClose} width={420}>
        {loading ? (
          <DocumentsLoader />
        ) : (
          <>
            {src && src.length ? (
              <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                  <div className="card">
                    <div className="card-body p-1">
                      {FILE_TYPES.PDF === fileType && (
                        <img
                          src={PDFIcon}
                          className="img-fluid"
                          style={{ width: "100%", height: "180px" }}
                          alt={
                            cardItem.paymentReceiptFileName ||
                            cardItem.paymentReceiptsFileName
                          }
                        />
                      )}
                      {FILE_TYPES.PNG === fileType && (
                        <img
                          src={src}
                          className="img-fluid"
                          style={{ width: "100%", height: "180px" }}
                          alt={
                            cardItem.paymentReceiptFileName ||
                            cardItem.paymentReceiptsFileName
                          }
                        />
                      )}
                      {FILE_TYPES.JPG === fileType && (
                        <img
                          src={src}
                          className="img-fluid"
                          style={{ width: "100%", height: "180px" }}
                          alt={
                            cardItem.paymentReceiptFileName ||
                            cardItem.paymentReceiptsFileName
                          }
                        />
                      )}

                      {/* Download File Button */}
                      <a
                        href={src}
                        className="btn btn-primary btn-sm w-100 mt-2"
                        download={
                          cardItem?.paymentReceiptFileName ||
                          cardItem?.paymentReceiptsFileName
                        }
                      >
                        Download File
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <DocumentNotFound onClose={onClose} />
            )}
          </>
        )}
      </Drawer>
    </>
  );
};

export default ViewDocumentDrawer;
